// src/pages/Publisher/Support/components/SupportTable.tsx
import React from 'react';
import { SupportTicket } from '../types';
import SupTableRow from './SupTableRow';

interface Props {
  data: SupportTicket[];
  anchorEl: HTMLElement | null;
  rowIdx: string | null;
  onMenuOpen(e: React.MouseEvent<HTMLElement>, idx: string): void;
  onMenuClose(): void;
  onDelete(idx: string): void;
  onArchive(idx: string): void;
}

/* --- head labels & minimum column widths --- */
const headers = ['Date', 'ID', 'Issue', 'Description', 'Status', 'More'];
const colWidths = [
  'text-left w-[10%]',
  'text-left w-[32%]',
  'text-left w-[10%]',
  'text-left w-[26%]',
  'text-left w-[12%]',
  'text-right w-[10%]',
];

const SupportTable: React.FC<Props> = ({
  data,
  anchorEl,
  rowIdx,
  onMenuOpen,
  onMenuClose,
  onDelete,
  onArchive,
}) => (
  /* A. full-height wrapper */
  <div className='relative h-full'>
    {/* B. unified scroll area (both X & Y) */}
    <div className='absolute inset-0 overflow-auto'>
      {/* C. single table: stretches if room, scrolls if not */}
      <table className='w-full min-w-max table-fixed text-left'>
        <colgroup>
          {colWidths.map((w, i) => (
            <col key={i} className={w} />
          ))}
        </colgroup>

        {/* Sticky header */}
        <thead className='sticky top-0 bg-white z-10 border-b'>
          <tr>
            {headers.map((h, i) => (
              <th
                key={i}
                className={`px-4 py-[18px] font-bold whitespace-nowrap ${
                  i === headers.length - 1 ? 'pr-[21px]' : ''
                }`}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>

        {/* Body */}
        <tbody>
          {data.map((ticket, i) => (
            <SupTableRow
              key={i}
              ticket={ticket}
              idx={ticket.id}
              anchorEl={anchorEl}
              rowIdx={rowIdx}
              onMenuOpen={onMenuOpen}
              onMenuClose={onMenuClose}
              onDelete={onDelete}
              onArchive={onArchive}
            />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default SupportTable;
